import React from 'react';
import cx from 'classnames';
import { t, props } from 'tcomb-react';

@props({
  width: t.Str,
  boxes: t.Any
})
export default class BoxesColumn extends React.Component {

  getContainerClasses() {
    const width = this.props.width;

    return cx({
      'large-50': (width === 'large-50'),
      'large-33': (width === 'large-33'),
      'small-100': (width === 'small-100')
    });
  }

  render() {
    return (
      <div className={this.getContainerClasses()}>
        <div className="cell">
          { this.props.boxes }
        </div>
      </div>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/BoxesColumn.js
 **/